import { useState } from "react";
import { Grid, IconButton, TextField, Tooltip } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";

import ListTable from "./ListTable";

function TimeResearch() {
  const currentYear = new Date().getFullYear();
  const [startDate, setStartDate] = useState(`${currentYear}-01-01`);
  const [endDate, setEndDate] = useState(`${currentYear}-12-31`);
  const [reloadKey, setReloadKey] = useState(0);

  const handleReload = () => {
    setReloadKey((prev) => prev + 1);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{
        overflow: "auto",
        maxHeight: "calc(100vh - 164px)",
        width: "calc(100% + 16px)",
      }}
    >
      <Grid item xs={3}>
        <TextField
          label="Từ ngày"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label="Đến ngày"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={3} style={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Tải lại dữ liệu">
          <IconButton color="primary" onClick={handleReload} size="small">
            <Refresh />
          </IconButton>
        </Tooltip>
      </Grid>
      <ListTable startDate={startDate} endDate={endDate} key={reloadKey} />
    </Grid>
  );
}

export default TimeResearch;
